export default "/_next/static/images/texture-4-f1b718d80d7548589e93ab27c7a8f62c.png";